<template>
    <div class="main-wrapper">
        <contact-map/>
        <contact-form/>
    </div>
</template>
<script>
    import ContactMap from "../components/contact/contactMap";
    import ContactForm from "../components/contact/contactForm";

    export default {
        components: {ContactForm, ContactMap}
    }
</script>